import ReactGA from 'react-ga'
import ReactGA4 from 'react-ga4'

import api from '../../../api.js'

export const types = {
  START_LOADING: 'Universe/startLoading',
  STOP_LOADING: 'Universe/stopLoading',
  SET_CURRENT_UNIVERSE: 'Universe/setCurrentUniverse',
  SET_UNIVERSES: 'Universe/setUniverses',
  CANCEL_LOADER: 'Universe/cancelLoader',
}

export function startLoading() {
  return {
    type: types.START_LOADING
  }
}

export function cancelLoader() {
  return {
    type: types.CANCEL_LOADER,
  }
}

export function stopLoading() {
  return {
    type: types.STOP_LOADING
  }
}

export function setUniverses(universes) {
  return {
    type: types.SET_UNIVERSES,
    universes
  }
}

/**
 * @param {object} universe
 * @returns {{universe: *, type: string}}
 */
export function setCurrentUniverse(universe) {
  return {
    type: types.SET_CURRENT_UNIVERSE,
    universe
  }
}

export function loadUniverses() {
  return async (dispatch) => {
    dispatch(startLoading())
    try {
      const universes = (await api.universes.getAll()).data
      dispatch(setUniverses(universes))
    } catch (e) {
      console.warn(e)
    } finally {
      dispatch(stopLoading())
    }
  }
}

/**
 * @param {object} universe
 * @returns {function(...[*]=)}
 */
export function loadUniverse(universe = null) {
  return (dispatch) => {
    dispatch(startLoading())
    try {
      dispatch(setCurrentUniverse(universe))
      ReactGA.set({dimension1: universe !== null ? universe.name : 'corporate'})
      ReactGA4.set({dimension1: universe !== null ? universe.name : 'corporate'})
    } catch (e) {
      console.warn(e)
    } finally {
      dispatch(stopLoading())
    }
  }
}

/**
 * @param {number} universeId
 * @return {function(...[*]=)}
 */
export function loadUniverseById(universeId = null) {
  return (dispatch, getState) => {
    const universe = getState().universe.universes.reduce((acc, universe) => {
      if (universe.id === universeId) {
        acc = universe
      }
      return acc
    }, null)

    if (null !== universe) {
      dispatch(loadUniverse(universe))
    }
  }
}

export default {
  setUniverses,
  loadUniverse,
  cancelLoader,
}